import { render, staticRenderFns } from "./Eliteliga.vue?vue&type=template&id=50e32ca8&"
import script from "./Eliteliga.vue?vue&type=script&lang=ts&"
export * from "./Eliteliga.vue?vue&type=script&lang=ts&"
import style0 from "./Eliteliga.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports